export default __webpack_public_path__ + "static/media/lever_rgb_mark_standard_inverted_transparent.eb678ce2.png";